"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUDGET_WRITE_ROLES = exports.BUDGET_READ_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
exports.BUDGET_READ_ROLES = [Roles_1.Roles.CallmartBudget, Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartForecast];
exports.BUDGET_WRITE_ROLES = [Roles_1.Roles.CallmartBudget];
